import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as service from '../../../services/inquiryEmailTemplate.service';
import Breadcrums from '../../../common/breadcrumbs';
import { SWAL_SETTINGS } from '../../../../../utils/Constants';

const InquiryEmailTemplateAdd = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const breadcrumbs = [
    { title: 'Dashboard', url: '/admin/dashboard' },
    { title: 'Inquiry Email Templates', url: '/admin/cms/inquiry-email-templates/list/1' },
    { title: 'Add', url: '' },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append('title', title);
      fd.append('subject', subject);
      fd.append('body', body);
      const res = await service.Add(fd);
      if (res.success) {
        Swal.fire({ icon: 'success', text: res.message, ...SWAL_SETTINGS })
          .then(() => navigate('/admin/cms/inquiry-email-templates/list/1'));
      } else {
        Swal.fire({ icon: 'error', text: res.message, ...SWAL_SETTINGS });
      }
    } catch (err) {
      Swal.fire({ icon: 'error', text: 'Something went wrong', ...SWAL_SETTINGS });
    }
    setSubmitting(false);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="main-content-label mb-3">Add Inquiry Email Template</h6>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Title <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" value={title}
                    onChange={e => setTitle(e.target.value)} required placeholder="Template title" />
                </div>
                <div className="form-group mt-3">
                  <label>Subject <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" value={subject}
                    onChange={e => setSubject(e.target.value)} required placeholder="Email subject" />
                </div>
                <div className="form-group mt-3">
                  <label>Body <span className="text-danger">*</span></label>
                  <textarea className="form-control" rows={8} value={body}
                    onChange={e => setBody(e.target.value)} required placeholder="Email body content" />
                </div>
                <div className="mt-4">
                  <button type="submit" className="btn btn-primary me-2" disabled={submitting}>
                    {submitting ? 'Saving...' : 'Save'}
                  </button>
                  <button type="button" className="btn btn-dark"
                    onClick={() => navigate('/admin/cms/inquiry-email-templates/list/1')}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InquiryEmailTemplateAdd;
